<template>
  <div class="part-container">
    <!-- 头部 -->
    <div class="part-header" >
      <div class="header-title">相关视频</div>
      <div class="header-more" v-if="showMore" @click="handleMore"><span class="plus">+</span>&nbsp;&nbsp;更多</div>
    </div>

    <!-- 内容区域 -->
    <div class="videos-content" >
      <!-- 视频网格 -->
      <div class="videos-grid" :class="{ 'no-data': !displayVideos || displayVideos.length === 0 }">
        <!-- 有视频数据时显示视频 -->
        <template v-if="displayVideos && displayVideos.length > 0">
          <div
            v-for="(video, index) in displayVideos.slice(0, 3)"
            :key="index"
            class="video-item"
            @click="handleVideoClick(video, index)"
          >
            <div class="video-wrapper">
              <img :src="video.coverOssKey || video.coverUrl" :alt="video.title" class="cover" />

              <!-- 左下角标题 -->
              <div class="video-overlay">
                <div class="video-name">{{ video.customName }}</div>
              </div>

              <!-- 右下角播放按钮 -->
              <img class="play-button" src="/assets/~/media/images/ai/play-icon.png" alt="播放" />
            </div>
          </div>
        </template>
        
        <!-- 无视频数据时显示整体占位符 -->
        <div v-else class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-video.png" alt="暂无视频内容" class="no-data-image" />
          <p class="no-data-text">暂无视频内容</p>
        </div>
      </div>
    </div>

    <!-- 自定义 PC 视频预览弹窗 -->
    <div class="video-preview-cover" v-if="previewVisible">
      <div class="pop">
        <div class="pop-video">
          <video
            v-if="previewVideo.ossKey"
            ref="previewVideoEl"
            class="preview-video"
            :src="previewVideo.ossKey"
            playsinline
            controls
            @play="onVideoPlay"
            @pause="onVideoPause"
            @ended="onVideoPause"
          />
          <!-- 中心播放按钮（暂停时显示） -->
          <img
            v-if="!isVideoPlaying"
            class="center-play"
            src="/assets/~/media/images/ai/play-icon.png"
            alt="播放"
            @click.stop="handleCenterPlay"
          />
          <!-- 底部信息与导航 -->
          <div class="caption-bar">
            <div class="caption-left">{{ previewVideo.customName }}</div>
            <div class="caption-right">
              <button class="nav-btn prev" :disabled="disablePrev" @click.stop="showPrev" aria-label="上一个">‹</button>
              <span class="counter">{{ displayIndex }}/{{ totalInPagePadded }}</span>
              <button class="nav-btn next" :disabled="disableNext" @click.stop="showNext" aria-label="下一个">›</button>
            </div>
          </div>
        </div>
        <img
          class="error-icon"
          src="/assets/~/media/images/icon/close-white.png"
          alt="关闭"
          @click="handlePreviewClose"
        >
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DetailVideo',
  props: {
    // 视频数据列表（后端分页每页返回的数据）
    videos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      previewVisible: false,
      previewVideo: {
        ossKey: '',
        customName: '',
      },
      currentIndex: 0,
      isVideoPlaying: false,
    };
  },

  // watch: {
  //   videos: {
  //     immediate: true,
  //     handler(newVal) {
  //       if (this.previewVisible && !this.previewVideo.ossKey && Array.isArray(newVal) && newVal.length > 0) {
  //         const first = newVal[0] || {};
  //         this.currentIndex = 0;
  //         this.previewVideo = {
  //           ossKey: first.ossKey || first.ossKey || '',
  //           title: first.title || '',
  //         };
  //         this.$nextTick(() => {
  //           const el = this.$refs.previewVideoEl;
  //           if (el) {
  //             try {
  //               el.pause();
  //               el.currentTime = 0;
  //             } catch (e) {}
  //           }
  //         });
  //       }
  //     }
  //   }
  // },
 
  computed: {
    displayVideos() {
      return this.videos;
    },
    showMore() {
      return Array.isArray(this.videos) && this.videos.length > 3;
    },
    totalInPage() {
      return (this.displayVideos && this.displayVideos.length) || 0;
    },
    displayIndex() {
      const idx = this.currentIndex + 1;
      return String(idx).padStart(2, '0');
    },
    totalInPagePadded() {
      return String(this.totalInPage).padStart(2, '0');
    },
    disablePrev() {
      return this.currentIndex <= 0 || this.totalInPage <= 0;
    },
    disableNext() {
      return this.totalInPage <= 0 || this.currentIndex >= this.totalInPage - 1;
    },
  },
  methods: {
    handlePageChange(p) {
      this.$emit('page-change', p);
    },
    handleVideoClick(video, index) {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关视频-第'+ (index+1) + '个视频', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关视频-第'+ (index+1) + '个视频');

      this.currentIndex = index;
      this.previewVideo = {
        ossKey: video.ossKey || video.ossKey,
        customName: video.customName || '',
      };
      this.previewVisible = true;
      this.$nextTick(() => {
        const el = this.$refs.previewVideoEl;
        if (el) {
          try {
            el.pause();
            el.currentTime = 0;
          } catch (e) {}
        }
      });
      // this.$emit('video-click', video);
    },
    updatePreviewByIndex() {
      if (!this.totalInPage) return;
      const clamped = Math.max(0, Math.min(this.currentIndex, this.totalInPage - 1));
      this.currentIndex = clamped;
      const v = this.displayVideos[clamped] || {};
      this.previewVideo = {
        ossKey: v.ossKey || v.ossKey || '',
        customName: v.customName || '',
      };
      this.$nextTick(() => {
        const el = this.$refs.previewVideoEl;
        if (el) {
          try {
            el.pause();
            el.currentTime = 0;
          } catch (e) {}
        }
      });
      this.isVideoPlaying = false;
    },
    showPrev() {
      if (!this.totalInPage || this.disablePrev) return;
      this.currentIndex = this.currentIndex - 1;
      this.updatePreviewByIndex();
    },
    showNext() {
      if (!this.totalInPage || this.disableNext) return;
      this.currentIndex = this.currentIndex + 1;
      this.updatePreviewByIndex();
    },
    handleCenterPlay() {
      const el = this.$refs.previewVideoEl;
      if (el) {
        try { el.play(); } catch (e) {}
      }
    },
    onVideoPlay() {
      this.isVideoPlaying = true;
    },
    onVideoPause() {
      this.isVideoPlaying = false;
    },
    handlePreviewClose() {
      this.previewVisible = false;
      this.previewVideo = { ossKey: '', customName: '' };
      this.currentIndex = 0;
      this.isVideoPlaying = false;
    },
    handleMore() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关视频- ”更多”按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关视频”更多”按钮');
      // 直接打开视频预览弹窗，从第四个视频开始
      if (this.videos.length > 3) {
        this.currentIndex = 3; // 从第4个视频开始（索引为3）
        this.updatePreviewByIndex();
        this.previewVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style/part.css';
.part-container {
  background-color: transparent;
}
.header-more {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .header-more .plus {
    font-size: calc((18 / 1920) * 100vw); /* 加号稍微大一点 */
    display: inline-block;
    transform: translateY(calc((0 / 1920) * 100vw)); /* 微调视觉对齐 */
  }
.videos-content {
  // padding: calc(10 / 1920 * 100vw) 0;
}

/* 视频网格样式（固定一行三个） */
.videos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: calc(10 / 1920 * 100vw);
  margin-bottom: calc(24 / 1920 * 100vw);
}

.video-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.video-item:hover {
  // transform: scale(1.02);
  z-index: 10;
}

.video-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 260 / 156;
  border-radius: calc(8 / 1920 * 100vw);
  overflow: hidden;
  background-color: #000;
}

/* 无数据时的整体占位符样式 */
.videos-grid.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(230, 232, 234, 1);
  border-radius: calc(8 / 1920 * 100vw);
  /* 使用与video-wrapper相同的宽高比计算高度 */
  width: 100%;
  aspect-ratio: 807 / 156;
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.no-data-image {
  width: calc(66 / 1920 * 100vw);
  height: calc(53 / 1920 * 100vw);
  margin-bottom: calc(8 / 1920 * 100vw);
  opacity: 0.5;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(12 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}

.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.video-wrapper:hover .cover {
  transform: scale(1.05);
}

/* 左下角标题覆盖层（始终显示） */
.video-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: calc(15 / 1920 * 100vw) calc(15 / 1920 * 100vw);
}

.video-name {
  width: 70%;
  color: #fff;
  font-size: calc(14 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 右下角播放按钮 */
.play-button {
  position: absolute;
  right: calc(15 / 1920 * 100vw);
  bottom: calc(12 / 1920 * 100vw);
  width: calc(35 / 1920 * 100vw);
  height: calc(35 / 1920 * 100vw);
  object-fit: contain;
  pointer-events: none; /* 点击穿透，整卡片可点击 */
}

/* PC 自定义视频弹窗样式（参照首页大电影） */
.video-preview-cover {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;

  .pop {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .pop-video {
    
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(1140 / 1080 * 100vh);
    // height: calc(684 / 1080 * 100vh);
    height: calc(641.25 / 1080 * 100vh);
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }

  .preview-video {
    width: 100%;
    height: 100%;
    background: #000;
  }

  /* 中央播放按钮 */
  .center-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(64 / 1080 * 100vh);
    height: calc(64 / 1080 * 100vh);
    cursor: pointer;
    user-select: none;
  }

  .error-icon {
    position: absolute;
    // top: calc(50vh - 342 / 1080 * 100vh - 0 / 1080 * 100vh);
    top: calc(50vh - 320 / 1080 * 100vh - 0 / 1080 * 100vh);
    left: calc(50vw + 570 / 1080 * 100vh + 10 / 1080 * 100vh);
    width: calc(30 / 1080 * 100vh);
    height: calc(30 / 1080 * 100vh);
    cursor: pointer;
  }

  .caption-bar {
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: calc(16 / 1080 * 100vh);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(16 / 1080 * 100vh) 0;
    pointer-events: none;
  }

  .caption-left {
    color: #fff;
    font-size: calc(16 / 1080 * 100vh);
    font-family: 'FZLanTingHeiS-B-GB';
    line-height: 1.4;
    pointer-events: auto;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }

  .caption-right {
    display: flex;
    align-items: center;
    gap: calc(8 / 1080 * 100vh);
    pointer-events: auto;
  }

  .counter {
    color: rgba(255, 255, 255, 1);
    font-size: calc(14 / 1080 * 100vh);
    margin: 0 calc(6 / 1080 * 100vh);
  }

  .nav-btn {
    width: calc(40 / 1080 * 100vh);
    height: calc(40 / 1080 * 100vh);
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 1);
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
  }

  .nav-btn:hover {
    background-color: lightgrey;
  }

  .nav-btn:disabled {
    background-color: lightgrey;
    cursor: not-allowed;
  }
}
</style>
